import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Dropdown, Grid, Icon, Input} from 'semantic-ui-react'
import { DATASOURCE } from 'Constants'
import qs from 'query-string'
import { translate } from 'react-i18next'
import { getApiData } from 'helpers/api'

class TenantFilter extends Component {
  constructor(props) {
    super(props);
    this.state = ({inputVal:""});
  }

  params = qs.parse(this.props.location.search);

  addTidToParams = (tid) => {
    let newParam = null === tid || undefined === tid ? undefined : tid.toLowerCase();
    if (newParam !== this.params.tid) {
      this.params.tid = newParam;
      let myUrl = this.props.location.pathname.replace(this.props.location.search,'');
      this.props.history.push(myUrl + "?" + qs.stringify(this.params));
    }
  }

  doSearch = () => {
    let newParam = this.state.inputVal ? this.state.inputVal : undefined;
    if (newParam !== this.params.domain) {
      this.params.domain = newParam;
      let myUrl = this.props.location.pathname.replace(this.props.location.search,'');
      this.props.history.push(myUrl + "?" + qs.stringify(this.params));
    }
  }

  doSearchWrapper = e => {
    if (e.key === "Enter") {
      this.doSearch();
      e.preventDefault()
      e.stopPropagation()
    }
  }

  handleInputChange = e => {
    this.setState({inputVal: e.target.value });
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      let p1 = qs.parse(this.props.location.search);
      let p2 = qs.parse(prevProps.location.search);
      if (p1.domain !== p2.domain && p1.domain !== "") {
        getApiData(DATASOURCE.TENANT_INFO, this.props.location.search);
      }
    }
    if (this.props.searchedCompany.name !== prevProps.searchedCompany.name) {
      this.addTidToParams(this.props.searchedCompany.stratusId);
    }
  }

  render() {
    const { t } = this.props;

    if (!this.props.hasAccess) {
      return null;
    }

    let userCompany = this.props.userCompany ? this.props.userCompany : t("TenantFilter.Mine");
    let currentSelection = userCompany;
    if (this.params.tid) {
      if (this.props.searchedCompany.stratusId === this.params.tid) {
        currentSelection = this.props.searchedCompany.name;
      } else if (this.params.tid === "all") {
        currentSelection = t("TenantFilter.All");
      }
    }

    return (
      <Grid.Column width={4}>
        <Icon className="polycom account circle" />&nbsp;
        <Dropdown 
          inline
          text={currentSelection}
        >
          <Dropdown.Menu>
            <Dropdown.Header content="Tenant's Domain" />
            <Input action={{ icon: 'search', onClick: () => this.doSearch()}}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
              }}
              onKeyDown={this.doSearchWrapper}
              onChange={this.handleInputChange}
            />
            <Dropdown.Header content="Datasets" />
            <Dropdown.Item text={userCompany} 
              onClick={(e) => {this.addTidToParams(null)}}
            />
            <Dropdown.Item text={t("TenantFilter.All")} 
              onClick={(e) => {this.addTidToParams("all")}}
            />
            {this.props.searchedCompany.name && this.props.searchedCompany.stratusId ? 
              (
                <Dropdown.Item text={this.props.searchedCompany.name}
                  onClick={(e) => {this.addTidToParams(this.props.searchedCompany.stratusId)}}
                />
              ) : null
            }
          </Dropdown.Menu>
        </Dropdown>
      </Grid.Column>
    )
  }
}

const mapToProps = state => {
  return {
    tenantId: state.userSession.tenantId,
    userCompany: state.tenantInfo.userCompany,
    loading: state.tenantInfo.loading,
    hasAccess: state.tenantInfo.hasAccess,
    searchedCompany: state.tenantInfo.searchedCompany
  }
};

export default translate()(
  connect(
    mapToProps,
    null
  )(TenantFilter)
);


